<!-- prettier-ignore -->

@if(chatForm){
  <div class="chat-input-wrapper">
    <input #inputChat
      type="text"
      [formControl]="getUserInputControl()"
      [(ngModel)]="inputText"
      (keydown.enter)="emitKeyDownEvent($event)"
      (keyup)="onKeyPress()"
      [readonly]="isStreaming()"
    />

    @if (!isStreaming() && !inputChat.value){
      <span class="text-placeholder" [class.dnone]="">{{'Escribe un mensaje...' | translate}}</span>
    }

    @if (isStreaming()){
      <span class="fake-placeholder" [class.dnone]="">{{'Esperando respuesta...' | translate}}</span>
    }

  </div>

}